<template>
    <van-popup v-if="projectCostDetailPopupShow " :value="projectCostDetailPopupShow" z-index="100" :close-on-click-overlay="false"
               :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">
        <div class="product_cost_detail_wrap" v-loading="loading">
            <div class="product_cost_detail_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                </div>
            </div>
            <div class="product_cost_detail_bottom">
                <div class="custom_title" >
                    <span>产品成本</span>
                </div>
                <div class="field_item">
                    总金额：{{stockCostDetail.total_price}}
                </div>

                <div class="custom_title" >
                    <span>出库成本</span>
                </div>

                <div class="field_item">
                    总金额：{{stockCostDetail.out_total_price}}
                </div>

                <div class="inventory_related_statistics">
                    <ul >
                        <li class="flex_js_wrap ellipsis" v-for="item in stockCostDetail.out">
                            <p class="ellipsis">{{item.name}}×{{item.total_num}}</p>
                            <p class="ellipsis">总价：{{item.total_cost}}</p>
                        </li>
                    </ul>
                </div>

                <div class="custom_title mt_16" >
                    <span>售后成本</span>
                </div>

                <div class="field_item">
                    总金额：{{stockCostDetail.in_total_price}}
                </div>

                <div class="inventory_related_statistics">
                    <ul>
                        <li class="flex_js_wrap ellipsis" v-for="item in stockCostDetail.in">
                            <p class="ellipsis">{{item.name}}×{{item.total_num}}</p>
                            <p class="ellipsis">总价：{{item.total_cost}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </van-popup>
</template>
<script>
import {ProjectManageStockCostDetail} from "@/api/index.js"
export default {
    name: "product_cost_detail",
    components: {

    },
    props: {
        projectCostDetailPopupShow: {
            type: Boolean,
            default: false
        },
        projectId: {
            type: Number,
            default: 0
        },

    },
    data() {
        return {
            loading: false,
            stockCostDetail:{}
        }
    },
    created() {
        if(this.projectId){
            this.getProjectManageCostDetail()
        }
    },
    methods: {
        getProjectManageCostDetail(){
            let postData = {
                project_manage_id:this.projectId
            }
            this.loading = true
            ProjectManageStockCostDetail(postData).then(res => {
                if (res.code === 200) {
                    this.stockCostDetail = res.data
                }
                this.loading = false
            })
        },
        handleClickClose() {
            this.$emit("update:projectCostDetailPopupShow", false)
        },

    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
</style>
